// t_skn_uketsuke_extends -> skn_sts_selecting_work_buhin
// 0: 未選択（初期状態 initialize）
// 1: 不要　（作業が不要　It does not need work.）
// 2: 選択済 (作業は選択済み Selecting is done.）

// t_skn_uketsuke_inspect  -> sts_selecting_buhin
// 0: 未選択 （初期状態 initialize）
// 1: 不要　（部品が不要　It does not need buhin.）
// 2: 選択済　（部品は選択済 Selecting is done.）

export const STATUS_SELECT_WORK_BUHIN = {
  Initial: 0,
  NoNeed: 1,
  Done: 2,
  FakeDone: 3 // for auto set same seibi
  , delete: 4
};
